import {
	FETCH_RECEIPT_LIST,
	FAIL_FETCH_RECEIPT_LIST,
	SET_RECEIPT_LIST_DATA,
	RESET_PROCESS_ERROR,
	GET_PDF_ITEMS_RECEIPT,
	FAIL_GET_PDF_ITEMS_RECEIPT,
	SET_PDF_ITEMS_RECEIPT,
	CLEAR_PDF_ITEMS_RECEIPT,
	SET_RECEIPT_LIST_STATE,
	RESET_RECEIPT_LIST_STATE,
	GET_PDF_ITEMS_RECEIPT_MOD,
	FAIL_GET_PDF_ITEMS_RECEIPT_MOD,
	SET_PDF_ITEMS_RECEIPT_MOD,
	CLEAR_PDF_ITEMS_RECEIPT_MOD,
	UNDO_RECEIPT_FLAG,
	FAIL_UNDO_RECEIPT_FLAG,
	SUCCESS_UNDO_RECEIPT_FLAG,
	GET_PDF_ITEMS_RECEIPT_SECOM,
	FAIL_GET_PDF_ITEMS_RECEIPT_SECOM,
	SET_PDF_ITEMS_RECEIPT_SECOM,
	CLEAR_PDF_ITEMS_RECEIPT_SECOM,
	FETCH_CSV_DATA_RECEIPT,
	FAIL_FETCH_CSV_DATA_RECEIPT,
	SET_CSV_DATA_RECEIPT,
	GET_RECEIPT_ARRIVAL_PDF,
	FAIL_GET_RECEIPT_ARRIVAL_PDF,
	SUCCESS_GET_RECEIPT_ARRIVAL_PDF, CLEAR_PDF_ITEMS_RECEIPT_ARRIVAL
} from '../actions';

import moment from 'moment';
import {downloadCsvData} from "../common/utils/download-csv";

const initialState = {
	data: [],
	isFetching: false,
	error: undefined,
	dateType: "1",
	selectedDateFrom: moment(),
	selectedDateTo: moment(),
	selections: [],
	sorts: [{columnName: 'NiukeshoStatusName', direction: 'desc'}],
	pdfPath: undefined,
	isProcessError: false,
	manualInputCount: 0,
	pdfPathMod: undefined,
	pdfPathSecom: undefined,
	ReceiptPdfPath: undefined,
	receiptArrivalPdfPath: undefined
};
export default function receiptListSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
	switch (action.type) {
		case FETCH_RECEIPT_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_RECEIPT_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_RECEIPT_LIST_DATA:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case SET_RECEIPT_LIST_STATE:
			return Object.assign({}, state, action.payload);
		case RESET_RECEIPT_LIST_STATE:
			Object.keys(initialState).forEach(key => {
				ret[key] = initialState[key];
			});
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		case GET_PDF_ITEMS_RECEIPT:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_PDF_ITEMS_RECEIPT:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_PDF_ITEMS_RECEIPT:
			ret.pdfPath = action.payload.pdfPath;
			ret.isFetching = false;
			return ret;
		case CLEAR_PDF_ITEMS_RECEIPT:
			ret.pdfPath = undefined;
			return ret;
		case GET_PDF_ITEMS_RECEIPT_MOD:
			ret.isFetching = true;
			return ret;
		case GET_PDF_ITEMS_RECEIPT_SECOM:
			ret.isFetching = true;
			ret.ReceiptPdfPath = action.payload.ReceiptPdfPath;
			return ret;
		case FAIL_GET_PDF_ITEMS_RECEIPT_MOD:
		case FAIL_GET_PDF_ITEMS_RECEIPT_SECOM:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			ret.ReceiptPdfPath = undefined;
			return ret;
		case SET_PDF_ITEMS_RECEIPT_MOD:
			ret.pdfPathMod = action.payload.pdfPath;
			ret.isFetching = false;
			return ret;
		case SET_PDF_ITEMS_RECEIPT_SECOM:
			if (!action.payload.pdfPath) {
				ret.pdfPathSecom = ret.ReceiptPdfPath;
			} else {
				ret.pdfPathSecom = action.payload.pdfPath;
			}
			ret.isFetching = false;
			return ret;
		case CLEAR_PDF_ITEMS_RECEIPT_MOD:
			ret.pdfPathMod = undefined;
			return ret;
		case CLEAR_PDF_ITEMS_RECEIPT_SECOM:
			ret.pdfPathSecom = undefined;
			ret.ReceiptPdfPath = undefined;
			return ret;
		case UNDO_RECEIPT_FLAG:
			ret.isFetching = true;
			return ret;
		case FAIL_UNDO_RECEIPT_FLAG:
			ret.isFetching = false;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_UNDO_RECEIPT_FLAG:
			ret.isFetching = false;
			ret.data = action.payload.consigneeData;
			return ret;
		case FETCH_CSV_DATA_RECEIPT:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_CSV_DATA_RECEIPT:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_CSV_DATA_RECEIPT:
			const csvData = action.payload.csvData;
			const columns = action.payload.columns;
			const now = moment().format('YYYYMMDDhhmmss');
			downloadCsvData("伝票" + now, columns, csvData);
			ret.isFetching = false;
			return ret;
		case GET_RECEIPT_ARRIVAL_PDF:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_RECEIPT_ARRIVAL_PDF:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_RECEIPT_ARRIVAL_PDF:
			ret.receiptArrivalPdfPath = action.payload.receiptArrivalPdfPath;
			ret.isFetching = false;
			return ret;
		case CLEAR_PDF_ITEMS_RECEIPT_ARRIVAL:
			ret.receiptArrivalPdfPath = undefined;
			return ret;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/receipt-list.js